<template>
<b-container>

<p class="h5 mb-4">{{pagePrompt}}</p>
<p class="h5 mb-4">{{$t('contactPage.pagePrompt2')}}</p>

<b-button v-b-modal.modal-contact variant="primary" style="margin-bottom:20px;" @click="contact.contactType = 'HM'">Add {{$t('contactPage.household')}}</b-button>
<b-button v-b-modal.modal-contact variant="primary" style="margin-bottom:20px;" @click="contact.contactType = 'SC'">Add {{$t('contactPage.social')}}</b-button>

  <b-list-group>
    <b-list-group-item class="d-flex justify-content-between align-items-center"
      v-for="(contact, idx) in contacts" v-bind:key="idx">
      {{contact.contactType === 'HM' ? 'Household Member' : 'Social Contact'}} - {{contact.firstName}} {{contact.lastName}}
      <b-button variant="primary" size="sm" @click="edit(idx)">Edit</b-button>
    </b-list-group-item>
  </b-list-group>

    <b-modal id="modal-contact" size="lg" hide-header hide-footer scrollable >
      <h2>Add {{headerTitle}}</h2>
      <hr/>
      <form ref="form" @submit.prevent="save">
        <b-row>
          <b-col cols="12" lg="6">
            <BaseTextInput v-model="contact.firstName" 
                                :v="$v.contact.firstName"
                                :label="$t('labels.contact-fname')"
                                slug="firstName"/>
          </b-col>
          <b-col cols="12" lg="6">
            <BaseTextInput v-model="contact.lastName" 
                                :v="$v.contact.lastName"
                                :label="$t('labels.contact-lname')"
                                slug="lastName"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <BaseTextInput v-model="contact.age" 
                                :v="$v.contact.age"
                                :label="$t('labels.contact-age', {name: contactName})"
                                slug="age"/>
          </b-col>
          <b-col cols="12" lg="6" v-show="false">
            <BaseRadioInput v-model="contact.liveTogether" 
                                :v="$v.contact.liveTogether"
                                :label="$t('labels.contact-liveTogether', {name: contactName})"
                                :options=yesNoOptions
                                slug="liveTogether"/>
          </b-col>
        </b-row>

        <div v-if="contact.age > 15">
        
          <b-row>
            <b-col cols="12" lg="6">
              <BaseMaskedTextInput v-model="contact.phone" 
                                  :v="$v.contact.phone"
                                  :label="$t('labels.contact-phone', {name: contactName})"
                                  mask="(###)###-####"
                                  slug="phone"/>
            </b-col>
            <b-col cols="12" lg="6">
              <BaseTextInput v-model="contact.email" 
                                  :v="$v.contact.email"
                                  :label="$t('labels.contact-email', {name: contactName})"                                  
                                  slug="email"/>
            </b-col>
          </b-row>

          <div v-if="contact.contactType === 'SC'">
            <b-row>
              <b-col cols="12" lg="12">
                <BaseTextInput v-model="contact.streetAddress" 
                                    :v="$v.contact.streetAddress"
                                    :label="$t('labels.street')"
                                    slug="streetAddress"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="12">
                <BaseTextInput v-model="contact.streetAddress2" 
                                    :v="$v.contact.streetAddress2"
                                    :label="$t('labels.street2')"
                                    slug="streetAddress2"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="3">
                <BaseTextInput v-model="contact.city" 
                            :v="$v.contact.city"
                            :label="$t('labels.city')"
                            slug="city"/>
              </b-col>
              <b-col cols="12" lg="3">
                <BaseSelector v-model="contact.state" 
                            :v="$v.contact.state"
                            :label="$t('labels.state')"
                            :options=stateOptions
                            slug="state"/>
              </b-col>
              <b-col cols="12" lg="3">
                <BaseMaskedTextInput v-model="contact.zip" 
                            :v="$v.contact.zip"
                            :label="$t('labels.zip')"
                            mask="#####-####"
                            slug="zip"/>
              </b-col>
            </b-row>
          </div>

          <b-row>
            <b-col cols="12" lg="12">
                <BaseMultiCheckboxInput v-model="contactSettingSelection" :v="$v.contactSettingSelection"
                      :label="$t('labels.contactSetting', {name: contactName})"
                      :options="contactSettingOptions"
                      slug="contactSetting"/>  
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" lg="12">
              <BaseRadioInput v-model="contact.namePermission" 
                            :v="$v.contact.namePermission"
                            :label="$t('labels.contact-namePermission', {name: contactName})"
                            :options=yesNoOptions
                            slug="namePermission"/>
            </b-col>
          </b-row>

          <b-row v-show="false">
            <b-col cols="12" lg="12">
              <BaseTextInput v-model="contact.employer" 
                            :v="$v.contact.employer"
                            :label="$t('labels.contact-employerName', {name: contactName})"
                            :tip="$t('tips.contact-employerName')"
                            slug="employer"/>
            </b-col>
          </b-row>
        
        </div>

        <b-row>
          <b-col>
            <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
            <b-button type="submit" variant="primary" :disabled="$v.contact.$invalid">Save</b-button>
          </b-col>
        </b-row>

      </form>
    </b-modal>


</b-container>

</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import moment from 'moment'
import _ from "lodash"
import i18n from '@/i18n'

export default {
    mixins: [
       commonOptions
    ],
  props: {
    symptoms: [Object]
  },
  data: () => ({
    contacts: [ ],
    editedIndex: -1,
    contact: {
      firstName: '',
      lastName: '',
      age: null,
      liveTogether: '',
      phone: '',
      email: '',
      healthCareWorker: null, 
      longTermCareWorker: null,
      groupHomeWorker: null,
      correctionalWorker: null,
      homelessShelterWorker: null,
      employer: '',
      contactType: '',
      namePermission: null,
      streetAddress: '',
      streetAddress2: '',
      city: '',
      state: 'MN',
      zip: '',
    },

    defaultContact: {
      firstName: '',
      lastName: '',
      age: null,
      liveTogether: '',
      phone: '',
      email: '',
      healthCareWorker: null, 
      longTermCareWorker: null,
      groupHomeWorker: null,
      correctionalWorker: null,
      homelessShelterWorker: null,
      employer: '',
      contactType: '',
      namePermission: null,
      streetAddress: '',
      streetAddress2: '',
      city: '',
      state: 'MN',
      zip: '',
    },
    contactSettingSelection: []
  }),

  computed: {
    _() {
      return this._
    },
    contactName() {
      return this.contact.firstName ? this.contact.firstName : 'Contact'
    },
    headerTitle() {
      return this.contact.contactType === 'HM' ? this.$i18n.t('contactPage.household', this.$root.$i18n.locale) :
         this.$i18n.t('contactPage.social', this.$root.$i18n.locale)
    },
    pagePrompt() {
      var exposePeriodStart
      if (this.symptoms.covidSymptoms === 'Y') {
        var startDate = moment(this.symptoms.covidSymptomsStart)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else if (this.symptoms.covidLastTested !== '') {
        startDate = moment(this.symptoms.covidLastTested)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else {
        exposePeriodStart = moment().subtract(2, 'days').format('MM/DD/YYYY')
      }

      return this.$i18n.t('contactPage.pagePrompt', this.$root.$i18n.locale, {date: exposePeriodStart})      
    }
  },
  
  watch: {
    contactSettingSelection() {
      this.contact.healthCareWorker = ''
      this.contact.longTermCareWorker = ''
      this.contact.groupHomeWorker = ''
      this.contact.correctionalWorker = ''
      this.contact.homelessShelterWorker = ''
      
      if (_.includes(this.contactSettingSelection, 'H')) {
        this.contact.healthCareWorker = 'Y'
      }
      if (_.includes(this.contactSettingSelection, 'N')) {
        this.contact.longTermCareWorker = 'Y'
      }
      if (_.includes(this.contactSettingSelection, 'G')) {
        this.contact.groupHomeWorker = 'Y'
      }
      if (_.includes(this.contactSettingSelection, 'C')) {
        this.contact.correctionalWorker = 'Y'
      }
      if (_.includes(this.contactSettingSelection, 'S')) {
        this.contact.homelessShelterWorker = 'Y'
      }
    }
  },
  validations() {
    return {
      contact: {
        firstName: { required},
        lastName: { required },
        age: { required, numeric },
        liveTogether: { required: false },
        phone: { required: false, 
          isValid(tel) {
            if (tel) {
              var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
              return phoneRegex.test(tel)
            } else {
              return true
            }
          } 
        },
        email: { required : false, email },
        healthCareWorker: { required : false },
        longTermCareWorker: { required : false },
        groupHomeWorker: { required : false },
        correctionalWorker: { required : false },
        homelessShelterWorker: { required : false },
        employer: { required : false },
        contactType: { required },
        namePermission: { required: false },
        streetAddress: { required: false, maxLength: maxLength(100) },
        streetAddress2: { required: false, maxLength: maxLength(100) },
        city: { required: false, maxLength: maxLength(75) },
        state: { required: false, maxLength: maxLength(2) },
        zip: { required: false, maxLength: maxLength(10) },
      },
      contactSettingSelection: { required: false },
      form: [  ]
    }
  },
  methods: {
    close () {
        this.$bvModal.hide('modal-contact')
        setTimeout(() => {
          this.contact = Object.assign({}, this.defaultItem)
          this.contactSettingSelection = [ ]
          this.editedIndex = -1
          this.$nextTick(() => { this.$v.contact.$reset() })
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
            Object.assign(this.contacts[this.editedIndex], this.contact)
        } else {            
            this.contacts.push(this.contact)
        }
        this.close()
      },

      edit (idx) {
        this.editedIndex = idx
        this.contact = Object.assign({}, this.contacts[idx])
         
        if (this.contact.healthCareWorker === 'Y') { this.contactSettingSelection.push('H')}
        if (this.contact.longTermCareWorker === 'Y') { this.contactSettingSelection.push('N')}
        if (this.contact.groupHomeWorker === 'Y') { this.contactSettingSelection.push('G')}
        if (this.contact.correctionalWorker === 'Y') { this.contactSettingSelection.push('C')}
        if (this.contact.homelessShelterWorker === 'Y') { this.contactSettingSelection.push('S')}

        this.$bvModal.show('modal-contact')
      },

      validate() {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data, isValid)
        return isValid
      }
  }
}
</script>

<style>

</style>
